import apis from "../../core/apis.js";

class CurrencyResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.currency).get(options);
  }

  get(id) {
    return this.$resource(apis.currency + id).get();
  }
}

export default CurrencyResource;



// WEBPACK FOOTER //
// ./src/resources/currency/currency.resource.js